import { find, get } from 'lodash';
import { applicationTypes } from 'constants/scripts';
import { getProductById } from 'products/selectors';

export const getBrandsByCrop = (state, crop) =>
  get(state, `products.${applicationTypes.SEED}.brandsByCrop.${crop}`, []);
export const getCertifiedHybridsForBrand = ({ state, brand }) =>
  get(state, `products.${applicationTypes.SEED}.certifiedHybridsByBrand.${brand}`, []);
export const getCertifiedProductById = (hybridsForBrand, id) => find(hybridsForBrand, { id });
export const getSeedProductById = (state, id) =>
  getProductById({ applicationType: applicationTypes.SEED, id, state });
